import { makeAutoObservable } from 'mobx'
import * as API from '../../../service/api/InfoStat/DashboardManageApi'

import storeIcon from '../../../assets/images/infoStat/statPanel/store_icon.png'
import deviceIcon from '../../../assets/images/infoStat/statPanel/device_icon.png'
import numIcon from '../../../assets/images/infoStat/statPanel/num_icon.png'
import { ITotalNumber, ITotaleNumProps } from 'models/InfoStat/StatPanel.model'

class DashboardManageStore {
  constructor() {
    makeAutoObservable(this)
  }

  getDashboardData = async () => {
    let res = await API.GET_DASHBOARD_DATA()
    return res
  }

  parseTotalNumData = (resp: ITotalNumber) => {
    const data: ITotaleNumProps[] = [
      {
        key: 1,
        name: '当前在线门店',
        num: resp.onLineOrgCount,
        url: storeIcon
      },
      {
        key: 2,
        name: '当前设备在线',
        num: resp.onLineVrCount,
        url: deviceIcon
      },
      {
        key: 3,
        name: '当前时段内容启动总次数',
        num: resp.startedCount,
        url: numIcon
      }
    ]
    return data
  }
}

export default new DashboardManageStore()
